import styled from "styled-components";

import { theme } from "styles/theme";

const ScreenGlass = styled.div`
  position: absolute;
  inset: 0;
  background-color: ${theme.colors.Black}60;
  z-index: 200;
`

export default ScreenGlass;